module.exports = __webpack_public_path__ + "static/example2-e43a3995b7c5b6d9fec16112137b180f.jpg";